import { InternalPage, MediaAsset, Sys } from 'libs/contentful/props';
import Link, { LinkProps } from '../Link/Link';
import ChimeKitIcon from './ChimeKitIcon';
import Media from '../Media/Media';

interface LinkWithIconComponentProps extends LinkProps {
  href?: string;
  chimeKitIconName?: string;
  icon?: MediaAsset;
  internalPage?: InternalPage;
  sys?: Sys;
}

const LinkWithIcon = ({
  children,
  href,
  chimeKitIconName,
  icon,
  internalPage,
  className,
  ...props
}: LinkWithIconComponentProps) => {
  const showIcon = chimeKitIconName != null;

  return (
    <Link href={href} internalPage={internalPage} className={className} {...props}>
      <div className="flex gap-2">
        <div className="w-6 flex-none">
          {showIcon && <ChimeKitIcon iconName={chimeKitIconName} />}
          {icon && <Media media={{ ...icon, width: 24, height: 24 }} className="w-full" />}
        </div>
        {children}
      </div>
    </Link>
  );
};

export default LinkWithIcon;
